import { Alert, Button, Descriptions, List, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { CsvUpdateResponse } from '../../model/csvupadte_request';

type Props = {
  show: boolean;
  response?: CsvUpdateResponse;
};

export const ErrorModal : React.FC<Props> = ({ show, response }) => {
  const [open, setOpen] = useState(show);

  useEffect(() => {
    setOpen(show);
  }, [show]);


  if (response === undefined) {
    return null;
  }

  const rows = response.rows.filter((row) => row.hasError);

  return (
        <Modal
            title={'不正な入力があります'}
            centered
            open={open}
            footer={() => {
              return (
                    <>
                        <Button onClick={() => setOpen(false)}>閉じる</Button>
                    </>
              );
            }}
            onCancel={() => setOpen(false)}
            width={800}
        >
            <Alert type={'error'} description={<>以下の行の値を修正の上再度更新を試みて下さい</>} />
            <List dataSource={rows} renderItem={(item) => {
              return (
                <List.Item>
                    <Descriptions bordered style={{ width: '100%' }}>
                        <Descriptions.Item contentStyle={{ width: '100px' }} label={'ID'}>{item.rowId}</Descriptions.Item>
                        <Descriptions.Item label={'内容'}>
                            {item.error || item.columns.filter((c) => c.validationResult === 'error').map((column) => {
                              return (
                                    <div key={column.key}>
                                        {column.error}
                                    </div>
                              );
                            })}
                        </Descriptions.Item>
                    </Descriptions>
                </List.Item>
              );
            }}/>
        </Modal>
  );
};
